import * as types from './checkLists.types';
export const checkListsPageSelectors: types.ICheckListPageSelectors = {
  selectCheckLists: (state) => state.page.checkLists.checkListsIds,
};
